<template>
  <div class="data-list">
    <div class="head-box">
      <search-box class="search-box">
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          label-width="100px"
        >
          <el-form-item label="活动名称" prop="code" label-width="120px">
            <el-input
              class="form-input"
              v-model="searchForm.code"
              size="small"
              clearable
              placeholder="请输入凭证号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="活动ID"
            prop="name"
            label-width="120px"
          >
            <el-input
              class="form-input"
              v-model="searchForm.name"
              size="small"
              clearable
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="经销商名称"
            prop="name"
            label-width="120px"
          >
            <el-input
              class="form-input"
              v-model="searchForm.name"
              size="small"
              clearable
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="业务凭证号"
            prop="name"
            label-width="120px"
          >
            <el-input
              class="form-input"
              v-model="searchForm.name"
              size="small"
              clearable
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="查询时间" prop="updatedTime" label-width="80px">
            <el-date-picker
              class="date-input"
              size="small"
              v-model="searchForm.updatedTime"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="-"
              start-placeholder="起始时间"
              end-placeholder="截至时间">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
      <div class="data-list-header">
        <div class="card-left">
          <el-row :gutter="10">
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header">
                  资金总结余
                  <el-tooltip class="item" effect="dark" content="=资金总收入-资金总支出" placement="top-start">
                    <i class="el-icon-question icon"></i>
                  </el-tooltip>
                </div>
                <div class="number">￥{{panelData.inProgress}}</div>
              </el-card>
            </el-col>
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header">
                  资金总收入
                  <el-tooltip class="item" effect="dark" content="=截止到昨天23:59内所有订单中的”收入金额“之和" placement="top-start">
                    <i class="el-icon-question icon"></i>
                  </el-tooltip>
                </div>
                <div class="number">￥{{panelData.end}}</div>
              </el-card>
            </el-col>
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header">
                  资金总支出
                  <el-tooltip class="item" effect="dark" content="截止到昨天23:59内所有订单中的”支出金额“之和" placement="top-start">
                    <i class="el-icon-question icon"></i>
                  </el-tooltip>
                </div>
                <div class="number">￥{{panelData.joinOrganization}}</div>
              </el-card>
            </el-col>
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header">
                  系统钱包总结余
                  <el-tooltip class="item" effect="dark" content="系统钱包总结余 =经销商总待提现”+”待核销+充值剩余“总资金" placement="top-start">
                    <i class="el-icon-question icon"></i>
                  </el-tooltip>
                </div>
                <div class="number">￥{{panelData.joinCustomer}}</div>
              </el-card>
            </el-col>
            <el-col :span="3">
              <el-card :body-style="{ padding: '0' }">
                <div class="header">
                  经销商总待提现
                </div>
                <div class="number">￥{{panelData.joinCustomer}}</div>
              </el-card>
            </el-col>
            <el-col :span="4">
              <el-card :body-style="{ padding: '0' }">
                <div class="header"> "待核销+充值剩余"总资金</div>
                <div class="number">￥{{panelData.joinCustomer}}</div>
              </el-card>
            </el-col>
            <el-col :span="5">
              <el-card :body-style="{ padding: '0' }">
                <div class="card">
                  <div class="title">资金正常</div>
                  <div class="middle">
                    <div class="item">资金总结余</div>
                    <span class="line">=</span>
                    <div class="item">系统钱包总结余</div>
                  </div>
                  <div class="tips">最近一次核对时间：2023年10月10日10:00</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <content-panel>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">核对</el-button>
          <el-button type="primary" size="small" @click="jumpRecord">资金核对记录</el-button>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">导出</el-button>
          <span style="margin-left: 4px">最近一次核对时间：2023年10月10日 10:30</span>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="code" label="序号" align="center" width="140"></el-table-column>
          <el-table-column prop="name" label="交易时间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="customer" label="收入金额" width="120" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createNum" label="支出金额" align="center" width="160"></el-table-column>
          <el-table-column prop="activityJoinNum" label="涉及手续费" align="center" width="160"></el-table-column>
          <el-table-column prop="pullNew" label="涉及活动名称" align="center" width="160"></el-table-column>
          <el-table-column prop="joinNum" label="涉及活动ID" align="center" width="160"></el-table-column>
          <el-table-column prop="joinNum" label="涉及经销商名称" align="center" width="160"></el-table-column>
          <el-table-column prop="joinNum" label="业务说明" align="center" width="160"></el-table-column>
          <el-table-column prop="joinNum" label="业务凭证号" align="center" width="160"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        code: "",
        name: "",
        parentIdCode: "",
        updatedTime: [],
      },
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      activeName: 'first',
    };
  },
  methods: {
    init() {
      this.getList();
      this.getOrgBoardInfo()
    },
    getOrgBoardInfo() {
      this.$api.dataReport.orgBoardInfo()
      .then( res => {
        this.panelData = res.data
      })
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport.orgDateReportPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === "updatedTime" && val) {
          this.filterParam.startTime = val[0] || "";
          this.filterParam.endTime = val[1] || "";
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;

      if (actionType == 3) {
        this.openSubPage({
          name: "manageList",
          params: row,
        });
      }else if(actionType == 1) {
        let params = {
          ...this.filterParam
        };
          this.$api.common.doExport('orgDateReportPageList', params).then(() => {
            this.$message.success('导出操作成功，请前往导出记录查看详情');
        });
      }
    },
    jumpRecord() {
      this.openSubPage({
        path: '/dataReport/capital-record'
      })
    }
  },
  filters: {},
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .head-box {
    margin: 0 15px;
    padding: 10px;
    padding-top: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background: #fff;
  }
  .date-input  {
    width 220px !important
  }
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border-bottom: 1px solid #ccc;
    }
    .number {
      height: 50px;
      text-align: center;
      line-height: 50px;
      text-align: center;
    }
    .card {
      padding: 10px;
      .title {
        padding: 6px 0;
        color: #fff;
        text-align: center;
        border-radius: 4px;
        background: #0BB78E;
      }
      .middle {
        display: flex;
        margin-top: 4px;
        .item {
          width: 50%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          align-items: center;
          color: #fff;
           border-radius: 4px;
          background: #0BB78E;
        }
        .line {
          color: #0BB78E;
          height: 30px;
          line-height: 30px;
          margin: 0 10px;
        }
      }
      .tips {
        text-align: center;
        margin-top: 4px;
      }
    }
  }
}
</style>
